import { ReactNode, createContext, useEffect, useState } from 'react'
import { HARDCODED_NODES, NodeData } from '../types/node'

const STORAGE_KEY = 'selectedNodeId'

interface NodeContextType {
  selectedNode: NodeData
  setSelectedNode: (node: NodeData) => void
}

const NodeContext = createContext<NodeContextType | undefined>(undefined)

export function NodeProvider({ children }: { children: ReactNode }) {
  const [selectedNode, setSelectedNode] = useState<NodeData>(() => {
    const savedNodeId = localStorage.getItem(STORAGE_KEY)
    const savedNode = HARDCODED_NODES.find((node) => node.id === savedNodeId)
    return savedNode || HARDCODED_NODES[0]
  })

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, selectedNode.id)
    // Dispatch custom event for same-window updates
    window.dispatchEvent(new Event('nodeChanged'))
  }, [selectedNode])

  return (
    <NodeContext.Provider value={{ selectedNode, setSelectedNode }}>
      {children}
    </NodeContext.Provider>
  )
}
